//个人中心路由
const userrouter = [
  {
    path: '/user',
    name: 'userindex',
    component: () => import('@/views/user/index'),
    meta: {
      keepAlive: false,
      title:'化纤大脑-个人中心'
    },
    children: [{
      path: 'personal',
      name: 'personal',
      component: () => import('@/views/user/module/personal-center')
    },{
      path: 'certificate',
      name: 'certificate',
      component: () => import('@/views/user/module/personal-certificate')
    }]
  }
]

export default userrouter



// WEBPACK FOOTER //
// ./src/router/user.js